// extracted by mini-css-extract-plugin
module.exports = {"category":"Category_category__3Sb5x","selected":"Category_selected__1DqRs","name":"Category_name__31Twq"};